import React, { useEffect, useState } from 'react'
import Header from "../../../common/header/Header"
import Kundli_Main_Banner from '../../kundli/kundli_main_bannner/Kundli_Main_Banner'
import Home_Private_Confidential from '../../home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../../../common/footer/Footer'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { Get_Astrologer_List } from '../../../../api/astrologer/Astrologer'
import Loader from '../../../../loader/Loader'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from "react-toastify";
import { X } from 'lucide-react'; // Optional: Close icon
import { Filter } from "lucide-react";
import { Helmet } from 'react-helmet'
import { get_Page_Seo } from '../../../../api/global/Global'
import parse from 'html-react-parser';


const Astrologer_List = () => {
    const token = User_Authentication()
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)

    const [pageSeo, set_Page_Seo] = useState({})

    const [is_loading, set_Is_Loading] = useState(false);
    const [astro_list, set_Astro_List] = useState([]);
    const [skills_list, set_Skills_List] = useState([]);
    const [languages_list, set_Language_List] = useState([]);
    const [selectedShort, setSelectedSort] = useState("popularity");
    const [showSort, setShowSort] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    const [globalFilter, setGlobalFilter] = useState("");
    const [globalFilterCountry, setGlobalFilterCountry] = useState("");

    const [is_Open_skill, set_is_Open_Skills] = useState(false);
    const [is_Open_Langauge, set_Is_Open_Langauge] = useState(false);
    const [is_Open_Gender, set_Is_Open_Gender] = useState(false);

    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState([]);
    const [selectedGender, setSelectedGender] = useState([]);

    const [minPrice, setMinPrice] = useState("0");
    const [maxPrice, setMaxPrice] = useState("");

    const genderFilter = [
        {
            id: 1,
            gender: "male"
        },
        {
            id: 2,
            gender: "female"
        }
    ]

    const filteredAstroList = astro_list?.filter((astro) => {
        const nameMatch = astro?.name?.toLowerCase()?.includes(globalFilter.toLowerCase());
        const countryMatch = astro?.astrodetail?.country?.toLowerCase()?.includes(globalFilterCountry.toLowerCase());

        // Both filters active
        if (globalFilter && globalFilterCountry) return nameMatch && countryMatch;

        // Only name filter active
        if (globalFilter) return nameMatch;

        // Only country filter active
        if (globalFilterCountry) return countryMatch;

        // No filters active
        return true;
    }) || [];


    const sortedAstroList = [...filteredAstroList].sort((a, b) => {
        switch (selectedShort) {
            case "experience_desc":
                return (b?.experience || 0) - (a?.experience || 0);
            case "experience_asc":
                return (a?.experience || 0) - (b?.experience || 0);
            case "orders_desc":
                return (b?.pooja_bookings_count || 0) - (a?.pooja_bookings_count || 0);
            case "orders_asc":
                return (a?.pooja_bookings_count || 0) - (b?.pooja_bookings_count || 0);
            case "price_desc":
                return (b?.astro_amounts?.audio_call_rate || 0) - (a?.astro_amounts?.audio_call_rate || 0);
            case "price_asc":
                return (a?.astro_amounts?.audio_call_rate || 0) - (b?.astro_amounts?.audio_call_rate || 0);
            case "rating_desc":
                return (b?.pooja_reviews_count || 0) - (a?.pooja_reviews_count || 0);
            case "popularity":
            default:
                return 0; // No sorting or default order
        }
    });



    // Calculate total pages safely
    const totalPages = Math.ceil(filteredAstroList.length / productsPerPage) || 1;

    // const totalPages = Math.ceil(filteredAstroList.length / productsPerPage) || 1;
    // const totalPages1 = Math.ceil(filteredAstroListByCountry.length / productsPerPage) || 1;

    // Calculate the products to display on the current page

    //  const startIndex = (currentPage - 1) * productsPerPage;
    //  const currentProduct = astro_list?.slice(startIndex, startIndex + productsPerPage) || [];
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = sortedAstroList.slice(startIndex, startIndex + productsPerPage);

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const toggle_skills_accordtion = () => {
        set_is_Open_Skills(!is_Open_skill);
    };
    const toggle_langauge_accordtion = () => {
        set_Is_Open_Langauge(!is_Open_Langauge);
    };
    const toggle_gender_accordtion = () => {
        set_Is_Open_Gender(!is_Open_Gender);
    };

    // <------------ handle origin Checkbox Change ----------->
    const handle_skill_checkbox_change = (originName) => {
        setSelectedSkills((prevSelected) =>
            prevSelected?.includes(originName)
                ? prevSelected?.filter((name) => name !== originName)
                : [...prevSelected, originName]
        );
    };
    // Comma-separated list of selected IDs
    const selectedSkillsString = selectedSkills.join(',');

    // <------------ handle origin Checkbox Change ----------->
    const handle_language_checkbox_change = (originName) => {
        setSelectedLanguage((prevSelected) =>
            prevSelected?.includes(originName)
                ? prevSelected?.filter((name) => name !== originName)
                : [...prevSelected, originName]
        );
    };
    // Comma-separated list of selected IDs
    const selectedLanguagesString = selectedLanguage.join(',');

    // <------------ handle gender Checkbox Change ----------->

    const handle_gender_checkbox_change = (genderName) => {
        setSelectedGender((prevSelected) =>
            prevSelected?.includes(genderName)
                ? prevSelected?.filter((name) => name !== genderName)
                : [...prevSelected, genderName]
        );
    };
    // Comma-separated list of selected IDs

    const selectedGenderString = selectedGender.join(',');


    // Handle changes to price inputs
    const handlePriceChange = (type, value) => {
        const price = Math.max(0, Math.min(100000, Number(value)));
        if (type === "min") setMinPrice(Math.min(price, maxPrice));
        if (type === "max") setMaxPrice(Math.max(price, minPrice));
    };

    const Handle_Get_astro_list = async () => {
        set_Is_Loading(true);
        try {
            // Pass the parameters to the API function
            const response = await Get_Astrologer_List("1", {
                skills: selectedSkillsString, languages: selectedLanguagesString,
                gender: selectedGenderString, min_amount: minPrice, max_amount: maxPrice, role_type: "astrologer"
            });
            if (response?.data?.status == "200") {
                set_Astro_List(response?.data?.data?.astrolist);
                const skills = response?.data?.data?.filter_by?.skills
                const languages = response?.data?.data?.filter_by?.languages

                const filtered_skills = skills?.filter((item, index, self) =>
                    index === self.findIndex((s) => s.skill === item.skill)
                );
                const filtered_language = languages?.filter((item, index, self) =>
                    index === self.findIndex((s) => s.language === item.language)
                );
                set_Skills_List(filtered_skills)
                set_Language_List(filtered_language)
                set_Is_Loading(false);
            } else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false);
            }
            else {
                set_Is_Loading(false);

            }
        } catch (error) {
            set_Is_Loading(false);
        }
    };


    // useEffect(() => {
    //     Handle_Get_astro_list()
    // }, [])

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        Handle_Get_astro_list();
    }, [selectedSkillsString, selectedLanguagesString, selectedGenderString, minPrice, maxPrice]);



    const handleSortChange = (value) => {
        setSelectedSort(value);
        setCurrentPage(1); // Reset to first page on sort change
    };

    const options = [
        { label: "Popularity", value: "popularity" },
        { label: "Experience : High to Low", value: "experience_desc" },
        { label: "Experience : Low to High", value: "experience_asc" },
        { label: "Total orders : High to Low", value: "orders_desc" },
        { label: "Total orders : Low to High", value: "orders_asc" },
        { label: "Price : High to Low", value: "price_desc" },
        { label: "Price : Low to High", value: "price_asc" },
        { label: "Rating : High to Low", value: "rating_desc" },
    ];

    useEffect(() => {
        document.body.style.overflow = showSort ? "hidden" : "auto";
        return () => (document.body.style.overflow = "auto");
    }, [showSort]);

    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Astrologer")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }

        Get_Page_Seo()
    }, [])
    return (
        <div>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}astrologer-list`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}astrologer-list`} />

            </Helmet>
            {/* <-------- Header section's ----------> */}
            <Header />
            {/*  */}
            {/* <Kundli_Main_Banner /> */}
            {/* <-------- ToastContainer ------------> */}
            {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <section className='banner-section'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover' />


                            </div>
                        </section>
                        <section className="gi-category py-[40px] max-[767px]:p-[15px]">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                                <div className="flex flex-wrap w-full">
                                    <div className="gi-shop-rightside min-[992px]:order-[6] min-[768px]:order-[-1] min-[992px]:w-[75%] min-[768px]:w-full w-full px-[12px]">
                                        <div className="gi-pro-list-top md:flex items-center justify-between text-[13px] mb-[15px]">
                                            <div className="w-full gi-grid-list">
                                                <h1 className="text-xl font-semibold text-gray-900">All Astrologer List</h1>
                                            </div>
                                            <div className='flex gap-3 justify-end w-full'>
                                                <button
                                                    onClick={() => { setShowSort(true) }}
                                                    className="w-[130px] inline-flex items-center space-x-1 border px-1 md:px-3 py-1.5 rounded text-[13px] font-medium text-gray-900 hover:bg-gray-100 transition"
                                                >
                                                    <Filter className="w-4 h-4" />
                                                    <span>Sort by</span>
                                                </button>

                                                <input
                                                    value={globalFilter ?? ""}
                                                    onChange={(event) => setGlobalFilter(event.target.value)}
                                                    placeholder="Search By name"
                                                    className="w-full md:w-1/3 rounded border border-gray-300 bg-white  px-4 py-2 text-[13px] text-gray-900 shadow-theme-xs"
                                                />
                                            </div>
                                        </div>

                                        {/* <!-- Shop content Start --> */}
                                        <div className="shop-pro-content">
                                            <div className="shop-pro-inner">
                                                <div className="grid md:grid-cols-3 gap-2">
                                                    {currentProduct?.map((astro_list_result) => {
                                                        return (
                                                            <Link to={`/astrologer/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`} className="grid_call_chat">
                                                                <div className="gi-product-content bg-white" >
                                                                    <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out overflow-hidden rounded-[5px] shadow-xl pt-3">
                                                                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">

                                                                            <div className="gi-pro-image overflow-hidden">

                                                                                <Link to={`/astrologer/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`}
                                                                                    className="image productimg relative block overflow-hidden pointer-events-none">
                                                                                    {
                                                                                        astro_list_result?.profile_image != null ? (
                                                                                            <img className="main-image rounded-full m-auto  w-[120px] h-[120px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                src={`${IMG_BASE_URL}${astro_list_result?.profile_image}`} alt={`${astro_list_result?.name}_profile`} />

                                                                                        ) : (

                                                                                            <img className="main-image rounded-full m-auto  w-[120px] h-[120px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                src={Common_Images_Transport?.user_logo} alt="astrologer" />
                                                                                        )
                                                                                    }
                                                                                </Link>

                                                                            </div>
                                                                        </div>
                                                                        <div className="gi-pro-content h-full p-3 pb-5 relative z-[10]  text-center">
                                                                            <div
                                                                                className="gi-pro-rat-price pb-2 flex justify-center gap-2 items-center">

                                                                                <span className="gi-pro-rating opacity-[0.7] relative">
                                                                                    {[...Array(5)].map((_, i) => {
                                                                                        const full = Math.floor(astro_list_result?.average_rating);
                                                                                        const isHalf = astro_list_result?.average_rating - full >= 0.5 && i === full;

                                                                                        return (
                                                                                            <span key={i} className="relative inline-block text-[14px] mr-[3px] w-[13px] h-[13px]">
                                                                                                <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                                                                                {i < full && (
                                                                                                    <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                                                                                )}
                                                                                                {isHalf && (
                                                                                                    <i
                                                                                                        className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                                                                                        style={{ width: '50%' }}
                                                                                                    />
                                                                                                )}
                                                                                            </span>
                                                                                        );
                                                                                    })}
                                                                                    {/* <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star text-[16px] text-gray-800 medium mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star text-[16px] text-gray-800 medium mr-[3px] float-left mr-[3px]"></i> */}
                                                                                </span>
                                                                                <span className="font-semibold text-[14px] text-white bg-red-400 px-3 rounded-full">
                                                                                    {astro_list_result?.average_rating > 0 ? astro_list_result?.average_rating.toFixed(1) : "0.0"}
                                                                                </span>
                                                                            </div>
                                                                            <Link to={`/astrologer/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`}>
                                                                                <h4 className="text-gray-800 text-[15px] font-semibold capitalize">{astro_list_result?.name}</h4>
                                                                            </Link>
                                                                            {/* <div className="mt-2">
                                                                                <div className="skills-container">
                                                                                    {astro_list_result?.skills && (
                                                                                        <span className="whitespace-nowrap inline-block text-gray-900 hover:text-white border border-gray-300 hover:bg-gray-900 rounded-full text-[13px] px-3 py-1 text-center">
                                                                                            {astro_list_result.skills.split(',')[0].trim()}
                                                                                        </span>
                                                                                    )}
                                                                                    {astro_list_result?.skills?.split(',').length > 1 && (
                                                                                        <span className="inline-block text-gray-500 text-[13px] ml-2">...</span>
                                                                                    )}
                                                                                </div>

                                                                                <div className="language-container">
                                                                                    {astro_list_result?.language && (
                                                                                        <span
                                                                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border border-gray-300 hover:bg-gray-900 rounded-full text-[13px] px-3 py-1 text-center"
                                                                                        >
                                                                                            {astro_list_result.language.split(',')[0].trim()}
                                                                                        </span>
                                                                                    )}
                                                                                    {astro_list_result?.language?.split(',').length > 1 && (
                                                                                        <span className="inline-block text-gray-500 text-[13px] ml-2">...</span>
                                                                                    )}
                                                                                </div>
                                                                                <span
                                                                                    className="whitespace-nowrap inline-block text-gray-900 hover:text-white border border-gray-300 hover:bg-gray-900 rounded-full text-[13px] px-3 py-1 text-center">
                                                                                    {astro_list_result?.experience}</span>
                                                                            </div> */}
                                                                            <div className="mt-1">
                                                                                <div className="skills-container">
                                                                                    {astro_list_result?.skills && (
                                                                                        <span
                                                                                            className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center"
                                                                                        >
                                                                                            Skills: <span className='text-gray-600 font-medium'>{astro_list_result?.skills?.replace(/,/g, ", ")}</span>
                                                                                        </span>
                                                                                    )}
                                                                                    {/* {astro_list_result?.skills?.split(',')?.length > 1 && (
                                                                    <span className="inline-block text-gray-500 text-[13px] ml-2">...</span>
                                                                )} */}
                                                                                </div>
                                                                                <div className="language-container">
                                                                                    {/* {astro_list_result?.language && ( */}
                                                                                    <span
                                                                                        className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center break-all"
                                                                                    >
                                                                                        Language: <span className='text-gray-600 font-medium'>{astro_list_result?.language?.replace(/,/g, ", ")}</span>
                                                                                    </span>
                                                                                    {/* )} */}
                                                                                    {/* {astro_list_result?.language?.split(',')?.length > 1 && (
                                                                    <span className="inline-block text-gray-500 text-[13px] ml-2">...</span>
                                                                )} */}
                                                                                </div>
                                                                                <span
                                                                                    className="text-gray-900 text-[12px] font-semibold text-center">Exp.<span className='text-gray-600 font-medium'>{astro_list_result?.experience} Yrs</span></span>
                                                                                <h6
                                                                                    className="gi-pro-stitle text-center font-normal text-[#000] text-[13px] font-semibold leading-[1.2] mt-4 capitalize">
                                                                                    Rs.{astro_list_result?.astro_amounts?.audio_call_rate}/min</h6>
                                                                            </div>


                                                                        </div>
                                                                        <div className="flex justify-between items-center border-t border-gray-200">
                                                                            <Link to='/download-app' className="text-center flex justify-center w-full p-3 px-6 hover:text-red-800 border-r border-gray-200 gap-2 text-[13px] items-center font-semibold">
                                                                                <img src={Common_Images_Transport?.call_icon} className="h-7"
                                                                                    alt="" />
                                                                                Call
                                                                            </Link>

                                                                            <Link to='/download-app'
                                                                                className="text-center flex justify-center w-full p-3 px-6 hover:text-red-800 gap-2 text-[13px] items-center font-semibold">
                                                                                <img src={Common_Images_Transport?.chat_icon} className="h-7"
                                                                                    alt="" />
                                                                                Chat
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                            {/* <!-- Pagination Start --> */}
                                            <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                <span className="text-[13px] text-gray-800 medium max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, astro_list?.length)} of {astro_list?.length} item(s)</span>
                                                <ul className="gi-pro-pagination-inner flex">
                                                    <li>
                                                        <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#e17d7d] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                            Prev
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPages).keys()].map((page) => (
                                                        <li key={page} className="inline-block float-left mr-[5px]">
                                                            <button
                                                                onClick={() => handlePageChange(page + 1)}
                                                                className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                        text-gray-800 medium leading-[32px] bg-[#e17d7d] flex text-center align-top 
                                                                        text-[16px] justify-center items-center rounded-[5px]
                                                                         ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}>
                                                                {page + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    <li>
                                                        <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#e17d7d] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="gi-shop-sidebar md:sticky top-[24px] min-[992px]:w-[25%] min-[768px]:w-full w-full max-[991px]:mt-[30px] px-[12px]">
                                        <div id="shop_sidebar">
                                            <div className="gi-sidebar-wrap p-[15px] rounded-[5px] shadow-lg">
                                                <h2 className="font-semibold text-lg"><i className="fi-rr-filter mr-2"></i> Filter</h2>
                                                {/* Sidebar Category Block */}
                                                <div className="gi-sidebar-block mb-4">
                                                    <div className="gi-sb-title border-b border-gray-200 pb-4">
                                                        <div className="text-red-700 text-lg mb-4 flex justify-between items-center cursor-pointer">


                                                            {/* Accordion Arrow */}
                                                            <span
                                                                className={`transform transition-transform ${is_Open_skill ? "rotate-180" : ""}`}
                                                                onClick={toggle_skills_accordtion}
                                                            >

                                                            </span>
                                                        </div>

                                                        <h3
                                                            className="gi-sidebar-title font-semibold text-gray-900 flex justify-between text-[13px] leading-tight cursor-pointer"
                                                            onClick={toggle_skills_accordtion}
                                                        >
                                                            Skills <i class="gicon gi-angle-down"></i>
                                                        </h3>
                                                    </div>
                                                    {/* Accordion Content */}
                                                    <div
                                                        className={`gi-sb-block-content transition-[max-height,opacity] duration-300 ease-in-out ${is_Open_skill ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                                                            }`}
                                                    >
                                                        <ul>
                                                            {skills_list?.map((origin_result) => {
                                                                return (
                                                                    <li key={origin_result?.id}>
                                                                        <div className="gi-sidebar-block-item py-3 flex flex-row relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                checked={selectedSkills?.includes(origin_result?.skill)}
                                                                                onChange={() => handle_skill_checkbox_change(origin_result?.skill)}
                                                                            />
                                                                            <p className="w-full text-gray-800 medium text-[13px] leading-[15px] capitalize cursor-pointer flex justify-between pl-[30px]">
                                                                                <span>{origin_result?.skill}</span>
                                                                            </p>
                                                                            <span
                                                                                className={`checked absolute top-1/2 left-0 h-4 w-4 border
                                                                                     bg-white transition-transform transform -translate-y-1/2 rounded
                                                                                      ${selectedSkills?.includes(origin_result?.skill) ? "bg-red-500 border-red-500" : ""
                                                                                    }`}
                                                                            ></span>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>


                                                </div>
                                                {/* Sidebar Category Block */}
                                                <div className="gi-sidebar-block mb-4">
                                                    <div className="gi-sb-title border-b border-gray-200 pb-4">

                                                        <h3
                                                            className="gi-sidebar-title font-semibold text-gray-900 flex justify-between text-[13px] leading-tight cursor-pointer"
                                                            onClick={toggle_langauge_accordtion}
                                                        >
                                                            Language <i class="gicon gi-angle-down"></i>
                                                        </h3>
                                                    </div>
                                                    {/* Accordion Content */}
                                                    <div
                                                        className={`gi-sb-block-content transition-[max-height,opacity] duration-300 ease-in-out ${is_Open_Langauge ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                                                            }`}
                                                    >
                                                        <ul>
                                                            {languages_list?.map((origin_result) => {
                                                                return (
                                                                    <li key={origin_result?.id}>
                                                                        <div className="gi-sidebar-block-item py-3 flex flex-row relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                checked={selectedLanguage.includes(origin_result?.language)}
                                                                                onChange={() => handle_language_checkbox_change(origin_result?.language)}
                                                                            />
                                                                            <p className="w-full text-gray-800 medium text-[13px] leading-[15px] capitalize cursor-pointer flex justify-between pl-[30px]">
                                                                                <span>{origin_result?.language}</span>
                                                                            </p>
                                                                            <span
                                                                                className={`checked absolute top-1/2 left-0 h-4 w-4 border bg-white transition-transform transform -translate-y-1/2 rounded ${selectedLanguage.includes(origin_result?.language) ? "bg-red-500 border-red-500" : ""
                                                                                    }`}
                                                                            ></span>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>


                                                </div>
                                                {/* Sidebar Category Block */}
                                                <div className="gi-sidebar-block ">
                                                    <div className="gi-sb-title border-b border-gray-200 pb-4">

                                                        <h3
                                                            className="gi-sidebar-title font-semibold text-gray-900 flex justify-between text-[13px] leading-tight cursor-pointer"
                                                            onClick={toggle_gender_accordtion}
                                                        >
                                                            Gender <i class="gicon gi-angle-down"></i>
                                                        </h3>
                                                    </div>
                                                    {/* Accordion Content */}
                                                    <div
                                                        className={`gi-sb-block-content transition-[max-height,opacity] duration-300 ease-in-out ${is_Open_Gender ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                                                            }`}
                                                    >
                                                        <ul>
                                                            {genderFilter?.map((gender_result) => {
                                                                return (
                                                                    <li key={gender_result?.id}>
                                                                        <div className="gi-sidebar-block-item py-3 flex flex-row relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                checked={selectedGender.includes(gender_result?.gender)}
                                                                                onChange={() => handle_gender_checkbox_change(gender_result?.gender)}
                                                                            />
                                                                            <p className="w-full text-gray-800 medium text-[13px] leading-[15px] capitalize cursor-pointer flex justify-between pl-[30px]">
                                                                                <span>{gender_result?.gender}</span>
                                                                            </p>
                                                                            <span
                                                                                className={`checked absolute top-1/2 left-0 h-4 w-4 border bg-white transition-transform transform -translate-y-1/2 rounded ${selectedGender.includes(gender_result?.gender) ? "bg-red-500 border-red-500" : ""
                                                                                    }`}
                                                                            ></span>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>


                                                </div>
                                                {/* Country */}
                                                {/* <div className="gi-sidebar-block mt-4">
                                                    <div className="gi-sb-title border-b border-gray-200 pb-4">

                                                        <h3
                                                            className="gi-sidebar-title font-semibold text-gray-900 flex justify-between text-[13px] leading-tight cursor-pointer"
                                                            onClick={toggle_gender_accordtion}
                                                        >
                                                            Country <i class="gicon gi-angle-down"></i>
                                                        </h3>
                                                    </div>
                                                    <div
                                                        className={`gi-sb-block-content transition-[max-height,opacity] duration-300 ease-in-out ${is_Open_Gender ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                                                            }`}
                                                    >
                                                        <ul>
                                                            {genderFilter?.map((gender_result) => {
                                                                return (
                                                                    <li key={gender_result?.id}>
                                                                        <div className="gi-sidebar-block-item py-3 flex flex-row relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                checked={selectedGender.includes(gender_result?.gender)}
                                                                                onChange={() => handle_gender_checkbox_change(gender_result?.gender)}
                                                                            />
                                                                            <p className="w-full text-gray-800 medium text-[13px] leading-[15px] capitalize cursor-pointer flex justify-between pl-[30px]">
                                                                                <span>{gender_result?.gender}</span>
                                                                            </p>
                                                                            <span
                                                                                className={`checked absolute top-1/2 left-0 h-4 w-4 border bg-white transition-transform transform -translate-y-1/2 rounded ${selectedGender.includes(gender_result?.gender) ? "bg-red-500 border-red-500" : ""
                                                                                    }`}
                                                                            ></span>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>


                                                </div> */}
                                                <div className="gi-sidebar-block mb-4">
                                                    <div className="gi-sb-title border-b border-gray-200 ">
                                                        <label className="gi-sidebar-title font-semibold text-gray-900 flex justify-between text-[13px] leading-tight  mt-2">
                                                            Country </label>
                                                        <input
                                                            value={globalFilterCountry ?? ""}
                                                            onChange={(event) => setGlobalFilterCountry(event.target.value)}
                                                            placeholder="Search By country"
                                                            className="w-full  rounded-lg border border-gray-300 bg-white  px-4 py-2 text-[13px] text-gray-900  mb-3  shadow-theme-xs mt-1"
                                                        />
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>

                            </div>
                        </section>
                        {/* <--------- Home_Private_Confidential --------> */}
                        <Home_Private_Confidential />
                        {/* <-------- Footer section's -------> */}
                        <Footer />
                        {showSort ? (
                            <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
                                <div className="bg-white w-72 rounded shadow-lg p-4 text-[13px] relative">
                                    {/* Header */}
                                    <div className="flex justify-between items-center mb-4">
                                        <h3 className="text-base font-semibold text-gray-800">SORT BY</h3>
                                        <button onClick={() => setShowSort(false)}>
                                            <X className="w-4 h-4 text-gray-500 hover:text-gray-900" />
                                        </button>
                                    </div>

                                    {/* Radio options */}
                                    <ul className="space-y-2">
                                        {options.map((opt) => (
                                            <li key={opt.value} className="flex items-center space-x-2 cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="sort_by"
                                                    id={opt.value}
                                                    value={opt.value}
                                                    checked={selectedShort === opt.value}
                                                    onChange={(e) => handleSortChange(e.target.value)}
                                                    className="accent-teal-600"
                                                />
                                                <label
                                                    htmlFor={opt.value}
                                                    className={`text-gray-900 ${selectedShort === opt.value ? "font-semibold" : ""}`}
                                                >
                                                    {opt.label}
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ) : null}
                    </>
                )
            }

        </div>
    )
}

export default Astrologer_List